import { Box, Center, Heading, SimpleGrid, Stack, Text } from '@chakra-ui/react';
import { CheckboxContainer } from 'formik-chakra-ui';
import CreateProfileButton from '../CreateProfileButton';
import { FormStep } from '../MultiStepForm';

export default function Skills(props: { onSubmit: any; formError: any; handleSkillCheckboxChange: any; skillsChoices: any; validationSchema: any }) {
    const { onSubmit, formError, handleSkillCheckboxChange, skillsChoices, validationSchema } = props;
    const skills: string[] = [
      '💻 Writing code',
      '🖍️ Drawing',
      '📝 Writing',
      '👏️ Leading a team',
      '🎒 Organization',
      '🗣 Public speaking',
      '🕰 Time management',
      '🔢 Math',
      '🤔 Critical thinking',
      '🗾 Planning',
      '📈 Analyzing data',
      '🎨 Designing'
  ];

  // get first half of skills array
  const firstHalfOfSkills = skills.slice(0, skills.length / 2);

  // get second half of skills array
  const secondHalfOfSkills = skills.slice(skills.length / 2);

  const skillOptions1 = firstHalfOfSkills.map((skill) => {
      return (
          <CreateProfileButton
              type="careers"
              name="skills"
              text={skill}
              key={skill}
              onChange={handleSkillCheckboxChange}
              isChecked={skillsChoices.includes(skill)}
              isDisabled={skillsChoices.length > 6}
          />
      );
  });

  const skillOptions2 = secondHalfOfSkills.map((skill) => {
      return (
          <CreateProfileButton
              type="careers"
              name="skills"
              text={skill}
              key={skill}
              onChange={handleSkillCheckboxChange}
              isChecked={skillsChoices.includes(skill)}
              isDisabled={skillsChoices.length > 6}
          />
      );
  });
    return (
        <FormStep stepName="skills" onSubmit={onSubmit} formError={formError} validationSchema={validationSchema}>
            <Center>
                <Box w="788px" h="28rem">
                    <Stack>
                        <Heading
                            fontSize="32px"
                            fontWeight={800}
                            width="800px"
                            display="flex"
                            justifyContent="center"
                        >
                            What comes{' '}
                            <Box color="#0F97FF" ml="8px" mr="8px">
                                {' '}
                                most naturally{' '}
                            </Box>
                            to you?
                        </Heading>
                        <Text fontWeight={400} fontSize="15px" color="#686672">
                            Select 3-5 choices.
                        </Text>
                        <Box>
                            <SimpleGrid
                                columns={2}
                                spacingX="38px"
                                spacingY={3}
                                mb={24}
                                h="100px"
                                alignSelf="center"
                            >
                                <CheckboxContainer name="compensation" h="48px">
                                    <Box align="right">{skillOptions1}</Box>
                                </CheckboxContainer>
                                <CheckboxContainer
                                    name="compensation"
                                    h="48px"
                                    alignItems="left"
                                    ml="-24px"
                                >
                                    <Box align="left">{skillOptions2}</Box>
                                </CheckboxContainer>
                            </SimpleGrid>
                        </Box>
                    </Stack>
                </Box>
            </Center>
        </FormStep>
    );
}
